<template>
    <div>
        <h2>Modifier mon adresse e-mail</h2>
        <form @submit.prevent="handleSubmit" class="FormMaterial m-t-30">
            <input-material @input="value => handleChange('email', value)"
                            label="Adresse e-mail"
                            type="email"
                            v-model="email"
                            :error="errors.email"/>

            <div class="text-center m-t-30">
                <button :disabled="loading" type="submit" class="Btn Btn--primary Btn--gradient Btn--shadow">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span v-else>Sauvegarder</span>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import {actions, getters} from "../../../store";
    import validate from "../../../validator/validator";
    import Rules from '../../../validator/rules';
    import {isEmpty} from "../../../utils";
    import InputMaterial from "../../InputMaterial";
    import ModalBus from "../../../eventBus";

    export default {
        components: {InputMaterial},
        data: function () {
            return {
                loading: false,
                email: getters.user().email,
                errors: {}
            };
        },
        methods: {
            handleChange(name) {
                delete this.errors[name];
            },
            async handleSubmit() {
                this.errors = validate({email: this.email}, {
                    email: [
                        Rules.required(),
                        Rules.email()
                    ]
                });

                if (!isEmpty(this.errors)) return;

                this.loading = true;
                try {
                    await actions.updateEmail(this.email);
                    ModalBus.alertSuccess('Adresse e-mail modifiée !', 'Votre adresse e-mail a bien été modifiée, vous devez désormais vous connecter avec cette dernière.');
                } catch (err) {
                    if (err.response?.data?.errors) {
                        this.errors = err.response.data.errors;
                        this.loading = false;
                    } else {
                        ModalBus.processingError();
                    }
                }
            }
        }
    }
</script>
